<!-- Encabezado -->
<div class="creative-people-area bg_image--50 ptb--200 ptb-md--80 ptb-sm--80">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="creative-people-inner text-center">
                    <h2 class="heading">Activador Akashico<sup>®</sup><span class="theme-color"> Luz Ilimitada</span></h2>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Creative People Area -->

<!-- Info del curso -->
<div class="bk-number-speaks section-ptb-xl bg_image--3">
    <div class="container">
        <div class="row">

            <div class="col-lg-6 col-xl-6 col-md-12 col-sm-12 col-12">
                <div class="number-speaks">
                    <div class="content wow move-up">
                        <h3 class="theme-color">Nuestro Objetivo</h3>
                        <h2>TRANSMITE <br> <span class="secondary-color">PRACTICA</span> Y ENSEÑA</h2>
                        <div class=""> <img src="assets/img/neuroakashico.png" alt="Escuela Akashica" style="margin-top: 15px;"></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xl-6 col-md-12 col-sm-12 col-12 mt_md--40 mt_sm--40">
                <div class="speakers-number-wrap">
                    
                   <h2>Selecciona tu nivel</h2>
                    <div class="tab">
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="pills-home-tab" data-toggle="pill"
                                    href="#pills-home" role="tab" aria-controls="pills-home"
                                    aria-selected="true">Facilitador</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="pills-profile-tab" data-toggle="pill"
                                    href="#pills-profile" role="tab" aria-controls="pills-profile"
                                    aria-selected="false" style="background: #491d6b; color: white; margin-left: 10px;">
                                    Practicante</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="pills-detalles-tab" data-toggle="pill"
                                    href="#pills-detalles" role="tab" aria-controls="pills-detalles"
                                    aria-selected="false" style="background: #f39302; color: white; margin-left: 10px;">
                                    +</a>
                            </li>
                            
                        </ul>
                        <div class="tab-content" id="pills-tabContent" >
                            <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                                aria-labelledby="pills-home-tab">
                                <div>
                                    <p><b>Activador Akashico® Luz Ilimitada® Facilitador</b>, es el eslabón para equilibrar la potencia cerebral hacia la transformación del gran Observador. </p>
                                    
                                    <ul>
                                        <li><b>Plataforma ELearning y Zoom </b>(Modalidad Online).</li>
                                        <li><b>Duración:</b>  1 mes, 1 clase semanal. <br>Total 4 clases semanales.</li>
                                    </ul>
                                    
                                    <span><b>Beneficios:</b></span>
                                    <ul>
                                        <li>Compartir y expandir a nivel nacional e internacional.</li>
                                        
                                    </ul>

                                    <span><b>Incluye:</b></span>
                                    <ul>
                                        <li>Manual y certificado como Facilitador.</li>
                                        <li>Cajita de Activador Akashico® Luz Ilimitada®.</li>
                                        <li>Registro en página web como Facilitador de Escuela Akashica®.</li>
                                        <li>Acceso a plataforma E-Learning con material y facilitar clases a otros.</li>
                                        <li>Constancia DS-3 de la Secretaría del Trabajo y Previsión Social de
                                            México</li>
                                        <li>Acompañamiento y contención.</li>
                                    </ul>

                                    <p>
                                        <b>Formas de pago: </b> por pay pal y/o a meses sin intereses mas pequeña
                                        comisión, transferencia, money gram, deposito.
                                    </p>
                                    <p>     <b>Comparte:</b> Ana Silvia Lara.<br>
                                            Fundadora de Escuela Akashica®<br>
                                            Akashic School Inc.<br>
                                            Creadora de NeuroAkashico®
                                                                </p>

                                    <app-aalifacilitador></app-aalifacilitador>
                                      


                                    
                                </div>
                            </div>
                            <div class="tab-pane fade" id="pills-profile" role="tabpanel"
                                aria-labelledby="pills-profile-tab" >
                                <div>
                                    <p><b>Activador Akashico® Luz Ilimitada®</b> es el combustible celular, que
                                        trabaja el sistema inmunitario aquel que se compone de redes celulares,
                                        órganos internos. Reparando y reconstituyendo tejidos.</p>
                                    
                                    <ul>
                                        <li><b>Plataforma ELearning y Zoom</b> (Modalidad Online).</li>
                                        <li><b>Duración:</b> 1 mes, 1 clase semanal, total 4 clases semanales</li>
                                    </ul>
                                    
                                    <span><b>Beneficios:</b></span>
                                    <ul>
                                        <li>Comunicación celular neuronal.</li>
                                        <li>Es rejuvenecedor celular y evita el envejecimiento.</li>
                                        <li>Trabaja la plasticidad cerebral y estabilidad del genoma.</li>
                                        <li>Regula el Metabolismo del ADN: replicacion, reparación, recombinación
                                            y transcripción.</li>
                                        <li>Repara y protege al ADN.</li>
                                        <li>Equilibra el Sistema Inmune.</li>
                                        <li>Regula los neurotransmisores, las hormonas y la proliferación celular.</li>
                                    </ul>

                                    <span><b>Temario:</b></span>
                                    <ul>
                                        <li>Qué es NeuroAkashico®️, Definición, beneficios y Aplicaciones</li>
                                        <li>Principios de Luz Ilimitada®️usos y aplicaciones.</li>
                                        <li>Qué es Activador Akashico®️ Luz Ilimitada®️, usos y aplicaciones.</li>
                                        <li>Aprende a realizar sesiones de Activador Akashico®️ Luz Ilimitada®️
                                            individual y grupal, presencial y a distancia, aplicado a niños, jóvenes
                                            y adultos.</li>
                                    </ul>

                                    <span><b>¿Qué incluye?</b></span>
                                    <ul>
                                        <li>Manual y Certificado</li>
                                        <li>Cajita de Activador Akashico® Luz Ilimitada®</li>
                                        <li>Registro en página web como Practicante de Escuela Akashica®</li>
                                        <li>Acceso a plataforma E-Learning con material, audios y clases grabadas.</li>
                                        <li>Constancia DS-3 de la Secretaría del Trabajo y Previsión Social de
                                            México</li>
                                        <li>Acompañamiento y contencion.</li>
                                    </ul>

                                    <p>
                                        <b>Formas de pago: </b> por pay pal y/o a meses sin intereses mas pequeña
                                        comisión, transferencia, money gram, deposito.
                                    </p>
                                    <p>     <b>Comparte:</b> Ana Silvia Lara.<br>
                                            Fundadora de Escuela Akashica®<br>
                                            Akashic School Inc.<br>
                                            Creadora de NeuroAkashico®
                                                                </p>
                                    
                                     <app-aalipracticante></app-aalipracticante>
                                      


                                    
                                </div>
                            </div>
                            <div class="tab-pane fade" id="pills-detalles" role="tabpanel"
                                aria-labelledby="pills-detalles-tab" >
                                <app-extrainfocursos></app-extrainfocursos>
                            </div>
                           
                        </div>
                    </div>
                  
                                   
               
                </div>
            </div>
        </div>
    </div>
</div>

<app-beneficios></app-beneficios>



